import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputGroup, TextField } from "@/src/common/components/ui";
import { GlobalSearchModal } from "./global-search-modal";

export function GlobalSearchBar() {
	const { t } = useTranslation("search");
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
				event.preventDefault();
				setIsOpen(true);
			}
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, []);

	const open = () => setIsOpen(true);

	return (
		<>
			<button type="button" onClick={open} aria-label={t("placeholder")} className="block w-full cursor-pointer text-left">
				<TextField className="w-full pointer-events-none" isReadOnly>
					<InputGroup>
						<InputGroup.Prefix>
							<Search size={20} />
						</InputGroup.Prefix>
						<InputGroup.Input placeholder={t("placeholder")} readOnly tabIndex={-1} />
					</InputGroup>
				</TextField>
			</button>

			<GlobalSearchModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</>
	);
}
